import * as React from 'react';

import { DashboardTrendGranularity } from './Dashboard.queries';

interface GranularityToggleProps {
  granularity: DashboardTrendGranularity;
  isActive: boolean;
  label: string;
  onSelect: (granularity: DashboardTrendGranularity) => void;
}

/**
 * Kept as a class so the click handler can be bound per instance — tslint's jsx-no-lambda
 * forbids creating the handler inline while mapping over the options.
 */
export class GranularityToggle extends React.PureComponent<GranularityToggleProps> {
  render() {
    const { isActive, label } = this.props;
    return (
      <button
        className={`Dashboard__toggle${isActive ? ' Dashboard__toggle--active' : ''}`}
        onClick={this.handleClick}
        type="button"
      >
        {label}
      </button>
    );
  }

  private readonly handleClick = () => this.props.onSelect(this.props.granularity);
}
